import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate, { Validator } from 'vee-validate';
import ru from './assets/dictonary/ru/';
import 'normalize.css';
import checkbox from '@component/checkbox.vue';
import '@styles/main.scss'
import moment from 'moment';
// import tooltipster from 'vue-tooltipster';
// import $ from 'jquery';
// import 'suggestions-jquery';


Vue.component('app-checkbox', checkbox)

Vue.use(VeeValidate, {
    locale: 'ru'
});

Validator.localize('ru', ru);

Vue.config.productionTip = false

Validator.extend('yearsMin18', {
    getMessage: 'Возраст должен быть более 18 лет',
    validate: value => {
        let target = moment()
            .subtract(18, 'year')
            .toDate();
        let formatedValue = moment(value, 'DD.MM.YYYY', true).toDate();
        return formatedValue < target;
    }
});

Vue.filter(
    'priceFormat',
    (value, currency) => {
        value = value.toString().split(' ')
        // if(value[1]){
        //     if(value[1].length == 1) {
        //         value[1]+=0
        //     }
        // } else {
        //     value[1] = '00'
        // }
        
        return `<div><span class="text-big">${value[0]}<span> <span class="text-small">${value[1]}</span> <span class="text-value">₽</span></div>`
    }
);

Validator.extend('notPast', {
    getMessage: 'Не раньше следующего дня',
    validate: value => {
        let target = moment()
            // .subtract(0, 'day')
            .toDate();
        let formatedValue = moment(value, 'DD.MM.YYYY', true).toDate();
        return formatedValue > target;
    }
});
Validator.extend('yearsMax17', {
    getMessage: 'Возраст должен быть менее 18 лет',
    validate: value => {
        let target = moment()
            .subtract(17, 'year')
            .toDate();
        let formatedValue = moment(value, 'DD.MM.YYYY', true).toDate();
        return formatedValue > target;
    }
});

Vue.filter('numeric',(value) => {
    return (value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

